import { TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import { useTranslation } from "react-i18next";
import { FIAT_CURRENCIES, HTTP_STATUSES, SERVICES } from "../../../../utils/consts";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import ProjectsSelect from "../../projects/ProjectsSelect";
import ServiceRelationshipsSelect from "../../serviceReletionships/ServiceRelationshipsSelect";
import TransactionType from "../select/TransactionTypeSelect";
import ConnectionsSelect from "../../connection/ConnectionsSelect";

const InvoiceFirstStep = ({ invoiceData, setInvoiceData, balanceInfo, direction }) => {
  const { t } = useTranslation("paymentsPage");

  const [additionalInfo, setAdditionalInfo] = useState();

  useEffect(() => {
    if (
        invoiceData.service?.name !== SERVICES.HRYVNIA8
      || invoiceData.currency?.asset !== FIAT_CURRENCIES.UAH
    ) {
      return;
    }

    if(!invoiceData.connection) {
        return;
    }

    let amount = invoiceData.amount ? invoiceData.amount : 0;

    axios.get("/api/hryvnia8-calculations?amount=" + amount +
        "&connectionId=" + invoiceData.connection?.id +
        "&direction=" + direction +
        "&currency=" + invoiceData.currency?.asset,
      userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setAdditionalInfo(response.data);
      }
    }).catch(error => {});
  }, [invoiceData.project, invoiceData.service, invoiceData.currency, invoiceData.amount, invoiceData.connection]);

  useEffect(() => {
      setInvoiceData({ ...invoiceData, "connection": null });
  }, [invoiceData.service]);

  return (
    <>
      <ProjectsSelect
        checkedProjects={invoiceData.project}
        setCheckedProjects={(data) => setInvoiceData({ ...invoiceData, "project": data })}
        isObject={true}
      />
      <ServiceRelationshipsSelect
        project={invoiceData.project}
        setCheckedServiceRelationships={(data) => setInvoiceData({
          ...invoiceData,
          "service": data.service,
          "currency": data.currency,
          "paymentSystem": data.paymentSystem
        })}
      />
        {invoiceData.project?.id && invoiceData.service?.name &&
            <ConnectionsSelect
                checkedConnection={invoiceData.connection}
                setCheckedConnection={(data) => setInvoiceData({ ...invoiceData, "connection": data })}
                project={invoiceData.project.id}
                service={invoiceData.service.name}
                isObject={true}
            />
        }
      {balanceInfo ?
        <Alert severity="info">
          <p>
            {t("create.form.balance")}: {balanceInfo.totalBalance} {balanceInfo?.currency}
          </p>
          <p>
            {t("create.form.holdingBalance")}: {balanceInfo.holdingBalance} {balanceInfo?.currency}
          </p>
          <p>
            {t("create.form.availableBalance")}: {balanceInfo.availableBalance} {balanceInfo?.currency}
          </p>
        </Alert> :
        <></>
      }
      <DelayInput
        id="amount"
        delayTimeout={2000}
        label={t("create.form.amount")}
        value={invoiceData.amount}
        onChange={(data) => setInvoiceData({ ...invoiceData, "amount": data.target.value.replace(/ /g, "") })}
        element={TextField}
      />
      {invoiceData.service?.name === SERVICES.HRYVNIA8 &&
        invoiceData.currency?.asset === FIAT_CURRENCIES.UAH &&
        additionalInfo &&
        <Alert severity="info">
          <p>
            {t("create.form.rate")}: {additionalInfo.rate}
          </p>
          <p>
            {t("create.form.usdtAmount")}: {additionalInfo.usdtAmount}
          </p>
        </Alert>
      }
      <TextField
        id="note"
        label={t("create.form.note")}
        value={invoiceData.note}
        onChange={(data) => setInvoiceData({ ...invoiceData, "note": data.target.value })}
      />
      <TextField
        id="relatedReferenceId"
        label={t("create.form.relatedReferenceId")}
        value={invoiceData.relatedReferenceId}
        onChange={(data) => setInvoiceData({ ...invoiceData, "relatedReferenceId": data.target.value })}
      />
      <TransactionType
        checkedTransactionType={invoiceData.transactionType}
        setCheckedTransactionType={(data) => setInvoiceData({ ...invoiceData, "transactionType": data })}
        direction={direction}
      />
    </>
  );
};

export default InvoiceFirstStep;